// extracted by mini-css-extract-plugin
export default {"container":"CardContainer_container__MMaYW"};